import React from 'react';

export default function Testimonials({ t }) {
  return (
    <section id="testimonials" className="bg-bg-soft border-t border-rule">
      <div className="max-w-content mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="mb-10 md:mb-14">
          <div className="font-mono text-[13px] tracking-eyebrow uppercase text-ink-3 mb-3.5">
            03 / {t.nav.testimonials}
          </div>
          <h2
            className="font-display font-medium text-ink m-0 mb-2"
            style={{ fontSize: 'clamp(32px, 4vw, 48px)', letterSpacing: '-0.02em', lineHeight: 1.05 }}
          >
            {t.testimonials.title}
          </h2>
          <p className="font-body text-[14px] text-ink-3 m-0">{t.testimonials.sub}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {t.testimonials.items.map((item, i) => (
            <div
              key={i}
              className="flex flex-col bg-surface border border-rule rounded-card p-6 transition-shadow duration-200 hover:shadow-[0_18px_40px_-24px_rgba(26,34,56,0.12)]"
            >
              <div
                className="font-display text-ink-3 leading-none mb-1 select-none"
                style={{ fontSize: 36, lineHeight: 1 }}
                aria-hidden="true"
              >
                &ldquo;
              </div>

              <p className="text-ink-2 leading-relaxed m-0 mb-6 flex-1" style={{ fontSize: 15 }}>
                {item.quote}
              </p>

              <div className="border-t border-rule pt-4">
                <div className="font-semibold text-ink mb-0.5" style={{ fontSize: 14 }}>
                  {item.name}
                </div>
                <div className="text-ink-3 mb-3" style={{ fontSize: 13 }}>
                  {item.title}
                </div>
                <div className="flex items-center justify-between">
                  <span className="font-mono text-[11px] text-ink-3 tracking-[0.04em] min-w-0 truncate mr-2">
                    {item.relation} · {item.date}
                  </span>
                  <a
                    href={t.testimonials.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 font-mono text-[11px] tracking-[0.04em] text-ink-2 border border-rule px-2.5 py-[5px] rounded-full hover:border-ink-3 transition-colors duration-150 no-underline whitespace-nowrap shrink-0"
                  >
                    {t.testimonials.cta} <span aria-hidden="true">↗</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
